import defaultCustomization from '../../constants/customization/defaultCustomization';

export default {
    authorization: `Bearer ${process.env.REACT_APP_JWT}`,
    integration: 'LOCALHOST',
    features: {
        F_ELEMENT_VIDEO: true,
        F_EDIT_HTML: true,
        F_IMAGE_LIBRARY: true,
        F_IMAGE_UPLOAD: true,
        F_COLOR_PALETTE: true,
        F_PREVIEW: true,
        F_DOWNLOAD_PDF: true,
        F_DOWNLOAD_HTML: true,
        F_SEND_TEST_EMAIL: true,
        F_SHARE_DRAFT: true,
        F_CUSTOM_FONTS: true,
        F_RTE: true,
        F_SUPPORT: true,
        F_ELEMENT_TOC: true,
        F_FEEDBACK: true,
        F_TUTORIALS: true,
        F_SAVE: true,
        F_SAVE_AS_TEMPLATE: true,
        F_VERSION_HISTORY: true,
    },
    collaboration: {
        connectedClients: [],
        currentUserSocketId: '',
        domain: '',
        id: '',
        trackID: '',
        versionID: '',
        type: '',
        access: 'owner',
        isConnected: false,
    },
    controls: ['save', 'download'],
    loading: true,
    user: {
        firstName: 'John',
        lastName: 'Doe',
        email: 'john_doe@bananatag.com',
        userID: 'SAMPLE_USER_ID',
        accountID: 'SAMPLE_USER_ID',
        parentID: 'SAMPLE_PARENT_ID',
        groupID: 'SAMPLE_USER_ID',
        plan: 'IC_ENTERPRISE',
        permission: 'ADMIN',
        isAdminOrParentAdmin: true,
        isIntegrationsEnabled: true,
        ipAddress: 'N/A',
        features: {
            EMAIL_DESIGNER_STYLING_ACCESS: true,
            EMAIL_DESIGNER_CUSTOMIZATION: false,
            EMAIL_DESIGNER_CUSTOM_FONTS: false,
            EMAIL_DESIGNER_VERSION_HISTORY: false,
            EMAIL_DESIGNER_RAW_IMAGE_UPLOA: false,
            EMAIL_DESIGNER_PERSONALIZATION: false,
            SURVEY_SOCIAL_REACTIONS: true,
            SURVEY_ENPS: true,
            SURVEYS_PULSE_CUSTOM: true,
            SURVEYS_PULSE_PRESET: true,
            CONTENT_LIBRARY_ACCESS: true,
        },
        customization: defaultCustomization,
    },
};
